module.exports = __webpack_public_path__ + "img/wenming-img.172a4e39.png";